<template>
  <div 
      class="flex flex-col items-center text-center 
        lg:items-start lg:text-left lg:flex-row-reverse lg:justify-around">

    <HomeGraphic
      class="pt-6"/>

    <div>
      <h1
        class="font-display text-6xl sm:text-display text-red-300 font-medium tracking-wider pt-8 lg:pt-0">
        aleksey</h1>
      <p
        class="text-gray-300 text-xl lg:text-2xl px-8 sm:px-16 pt-1 lg:w-3/4 lg:px-0 font-sans font-light leading-relaxed">
        I'm a <strong class="text-red-100">software engineer</strong> who favors <strong class="text-red-100">dirty hands</strong>, <strong class="text-red-100">clean UIs</strong>, <strong class="text-red-100">fast feedback loops</strong>, <strong class="text-red-100">rapid prototyping</strong>, and <strong class="text-red-100">just-in-time learning</strong>. I also like to work <strong class="text-red-100">across domains</strong>. Shoot me a message if you would like to collaborate on something interesting.</p>
      <div class="flex justify-center lg:justify-start space-x-8 pt-12 pb-12">
        <HomeSocial/>
      </div>
    </div>
  </div>
</template>

<script>
  import HomeGraphic from './HomeGraphic'
  import HomeSocial from './HomeSocial'

  export default {
    name: 'Home',
    components: { 
      HomeGraphic,
      HomeSocial
    }
  }
</script>

